import { DamImage } from './DamImage';
import register from './register';

register(DamImage);
